import axios from 'axios';
import qs from 'qs';
import Lockr from 'lockr';
// import { Message } from 'element-ui';
import * as util from '../utils/util';
import baseConfig from './config';
import router from '../router';

export default async function(url, pars, options) {
  const encrypt =
    'undefined' !== typeof options.encrypt ? options.encrypt : false; // 默认不加密
  const method = 'undefined' !== typeof options.method ? options.method : 'get';
  let tmp = pars;
  // 判断参数是否需要加密
  if (encrypt) {
    tmp = await util.encrypt(pars);
  }
  // 参数对象转querystring repeat数组形式为：a=1&a=2，通过该方式post，默认Content-Type = application/x-www-form-urlencoded'
  const params = qs.stringify(tmp, { arrayFormat: 'repeat' });
  // 自定义配置
  let customConfig = {
    url,
    method
  };
  // get请求通过url传参，post请求通过requestBody传参
  if (method === 'get') {
    customConfig.params = params;
  } else {
    customConfig.data = params;
  }
  // 合并基础配置和自定义配置
  const config = Object.assign({}, baseConfig, customConfig);
  // 发起请求
  return axios.request(config).then(response => {
    // 请求发送成功
    // console.log(response);
    const res = response.data;
    if (res.code === 1) {
      // 请求处理成功，直接返回数据到下一个then处理
      return res;
    }
    // 请求处理失败，根据错误码做进一步处理
    switch (res.code) {
      case 101: // 凭证无效
        // Message({
        //   message: '请求不合法，请重新登录',
        //   type: 'error'
        // });
        // 清空不合法的用户信息
        Lockr.rm('$state');
        // 跳转到登录页面
        router.push({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        });
        throw new Error('请求不合法');
      case 102: // 未授权
        // Message({
        //   message: '用户没有权限',
        //   type: 'error'
        // });
        throw new Error('用户没有权限');
      default:
        // Message({
        //   message: res.msg,
        //   type: 'error'
        // });
        throw new Error(res.msg);
    }
  });
}
